import { cn } from "@/lib/utils";
import { EmptyState } from "@/components/common/States";

export const DataTable = ({ columns, rows, rowKey, onRowClick, emptyTitle, emptyHint, dense = true, testId }) => (
  <div className="overflow-auto" data-testid={testId}>
    <table className="w-full text-xs border-collapse">
      <thead className="sticky top-0 z-10 bg-card">
        <tr className="border-b border-border">
          {columns.map((c) => (
            <th key={c.key} className={cn("px-3 py-2 text-left font-mono text-[10px] font-semibold uppercase tracking-wider text-muted-foreground whitespace-nowrap", c.align === "right" && "text-right", c.className)}>{c.header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={rowKey ? rowKey(row) : i} onClick={onRowClick ? () => onRowClick(row) : undefined}
            data-testid={`${testId || "table"}-row-${rowKey ? rowKey(row) : i}`}
            className={cn("border-b border-border/50 odd:bg-muted/20 hover:bg-accent/40 transition-colors", onRowClick && "cursor-pointer", dense ? "h-8" : "h-10")}>
            {columns.map((c) => (
              <td key={c.key} className={cn("px-3 py-1 whitespace-nowrap", c.align === "right" && "text-right font-mono", c.mono && "font-mono", c.cellClassName)}>
                {c.render ? c.render(row) : row[c.key] ?? "—"}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
    {rows.length === 0 && <EmptyState title={emptyTitle} hint={emptyHint} />}
  </div>
);
